<template>
  <section v-on:click="sectionClicked" class="features blockArticles">
    <div class="tabCnt" v-if="section.directory && section.directory.isEventDir === 1">
      <div class="cnt">
        <div class="tabItem" :class="{active: tabActive === 'upcoming'}"
          v-on:click="selectTab('upcoming')">
          <template v-if="lang === 'id'">Akan Datang</template>
          <template v-else>Upcoming</template>
        </div>
        <div class="tabItem" :class="{active: tabActive === 'past'}"
          v-on:click="selectTab('past')">
          <template v-if="lang === 'id'">Riwayat</template>
          <template v-else>Past Event</template>
        </div>
      </div>
    </div>
    <div class="cnt cntLoading" v-if="loading || section.loading"></div>
    <div class="cnt cntNoData" v-else-if="section.items.length < 1">
      <img src="../../assets/no-data.png">
      <h4 v-if="lang === 'id'">Tidak ada data untuk ditampilkan</h4>
      <h4 v-else>There is no data to display</h4>
      <p v-if="lang === 'id'">
        Saat ini belum ada data untuk ditampilkan, periksa kembali lagi nanti.
      </p>
      <p v-else>
        There is currently no data to display, please check back later.
      </p>
    </div>
    <div class="cnt" v-else>
      <div class="newsCnt" v-if="section.displayType === 'Slider' && section.items.length >= 4">
        <template v-if="section.items.length > 4">
          <div class="sp spl" v-on:click="prevSlide"
            v-if="swiper && !swiper.isBeginning"></div>
          <div class="sp spr" v-on:click="nextSlide"
            v-if="swiper && !swiper.isEnd"></div>
        </template>
        <div class="newsSc">
          <swiper
            :slidesPerView="1"
            :breakpoints="{1341:{slidesPerView: 4},841:{slidesPerView: 3},641:{slidesPerView: 2}}"
            :loop="false"
            ref="swiper"
            @swiper="onSwiper">
            <swiper-slide class="swiper-item newsItem"
              v-for="(n, i) in section.items" :key="`nws${i}`">
              <div class="newsIn">
                <a href="#" v-on:click.prevent="doNothing">
                  <div class="newsImg eventDate" v-if="n.type === 'event'
                    && section.config.displayType !== 'List'">
                    <div class="theDate">
                      <div class="edDate">
                        {{n.eventDate | moment('DD')}}
                      </div>
                      <div class="edMonth">
                        {{n.eventDate | moment('MMM YYYY')}}
                      </div>
                    </div>
                  </div>
                  <div class="newsImg" :class="n.coverStyle" v-else-if="n.thumbHd && n.thumbHd[lang]"
                    :style="{'background-image': `url(${n.thumbHd[lang]})`}"></div>
                  <div class="newsImg noImg" v-else></div>
                </a>
                <div class="newsInfo">
                  <a href="#" v-on:click.prevent="doNothing">
                    <h4>{{n.title[lang]}}</h4>
                  </a>
                  <div class="timestamp" v-if="n.type !== 'event'
                    && (n.displayAuthor || n.displayPublishDate || n.displayViews)">
                    <a href="#" v-on:click.prevent="doNothing"
                      v-if="n.displayPublishDate">
                      {{n.publishDate | moment(n.dateFormat || 'DD/MM/YYYY')}}
                    </a>
                    <a href="#" v-if="n.author && n.displayAuthor">
                      <span class="bull" v-if="n.displayPublishDate">&bull;</span>
                      {{n.author.name}}
                    </a>
                    <a href="#" v-on:click.prevent="doNothing"
                      v-if="n.displayViews">
                      <span class="bull" v-if="n.displayPublishDate || n.displayAuthor">&bull;</span>
                      <template v-if="n.viewCount > 1">
                        <template v-if="n.viewCount >= 1000000000">
                          {{Math.floor(n.viewCount/1000000000).toLocaleString('id')}}b
                        </template>
                        <template v-else-if="n.viewCount >= 1000000">
                          {{Math.floor(n.viewCount/1000000).toLocaleString('id')}}m
                        </template>
                        <template v-if="n.viewCount >= 1000">
                          {{Math.floor(n.viewCount/1000).toLocaleString('id')}}k
                        </template>
                        <template v-else-if="n.viewCount">
                          {{n.viewCount.toLocaleString('id')}}
                        </template>
                        views
                      </template>
                      <template v-else>{{n.viewCount || 0}} view</template>
                    </a>
                  </div>
                  <p class="newsDesc">{{n.description[lang]}}</p>
                </div>
                <a href="#" v-on:click.prevent="doNothing"
                  class="readMore">
                  <template v-if="lang === 'id'">Selengkapnya</template>
                  <template v-else>Read more</template>
                </a>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="newsCnt" v-else :class="section.displayType">
        <div class="newsSc">
          <div class="newsItem" v-for="(n, i) in section.items"
            :key="`nws${i}`" :class="n.type">
            <div class="newsIn">
              <a href="#" v-on:click.prevent="doNothing">
                <div class="newsImg eventDate" v-if="n.type === 'event'
                  && section.config.displayType !== 'List'">
                  <div class="theDate">
                    <div class="edDate">
                      {{n.eventDate | moment('DD')}}
                    </div>
                    <div class="edMonth">
                      {{n.eventDate | moment('MMM YYYY')}}
                    </div>
                  </div>
                </div>
                <div class="newsImg" :class="n.coverStyle" v-else-if="n.thumbHd && n.thumbHd[lang]"
                  :style="{'background-image': `url(${n.thumbHd[lang]})`}"></div>
                <div class="newsImg noImg" v-else></div>
              </a>
              <div class="newsInfo">
                <a href="#" v-on:click.prevent="doNothing">
                  <h4>{{n.title[lang]}}</h4>
                </a>
                <div class="timestamp eventTs" v-if="n.type === 'event'
                  && section.config.displayType === 'List'">
                  <div class="theDate">
                    <div class="edDate">
                      {{n.eventDate | moment('DD')}}
                    </div>
                    <div class="edMonth">
                      {{n.eventDate | moment('MMM YYYY')}}
                    </div>
                  </div>
                </div>
                <div class="timestamp" v-else-if="n.displayAuthor
                  || n.displayPublishDate || n.displayViews">
                  <a href="#" v-on:click.prevent="doNothing"
                    v-if="n.displayPublishDate">
                    {{n.publishDate | moment(n.dateFormat || 'DD/MM/YYYY')}}
                  </a>
                  <a href="#" v-if="n.author && n.displayAuthor">
                    <span class="bull" v-if="n.displayPublishDate">&bull;</span>
                    {{n.author.name}}
                  </a>
                  <a href="#" v-on:click.prevent="doNothing"
                    v-if="n.displayViews">
                    <span class="bull" v-if="n.displayPublishDate || n.displayAuthor">&bull;</span>
                    <template v-if="n.viewCount > 1">
                      <template v-if="n.viewCount >= 1000000000">
                        {{Math.floor(n.viewCount/1000000000).toLocaleString('id')}}b
                      </template>
                      <template v-else-if="n.viewCount >= 1000000">
                        {{Math.floor(n.viewCount/1000000).toLocaleString('id')}}m
                      </template>
                      <template v-if="n.viewCount >= 1000">
                        {{Math.floor(n.viewCount/1000).toLocaleString('id')}}k
                      </template>
                      <template v-else-if="n.viewCount">
                        {{n.viewCount.toLocaleString('id')}}
                      </template>
                      views
                    </template>
                    <template v-else>{{n.viewCount || 0}} view</template>
                  </a>
                </div>
                <p class="newsDesc">{{n.description[lang]}}</p>
              </div>
              <a href="#" v-on:click.prevent="doNothing"
                class="readMore">
                <template v-if="lang === 'id'">Selengkapnya</template>
                <template v-else>Read more</template>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="newsNav" v-if="section.displayViewAll">
        <a :href="section.viewAllUrl && section.viewAllUrl[lang]
          ? section.viewAllUrl[lang] : '#'" class="btn outline viewAll"
          v-on:click.prevent="doNothing">
          {{section.viewAllLabel[lang] || (lang === 'id' ? 'Lihat Semua' : 'View All')}}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { Navigation, Pagination } from 'swiper';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation, Pagination]);

export default {
  name: 'home',
  props: ['section', 'page'],
  components: { Swiper, SwiperSlide },
  data() {
    return {
      swiper: null,
      loading: false,

      /**
       * Event
       *
       */
      tabActive: 'upcoming',

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    prevSlide() {
      if (!this.swiper) return;
      this.swiper.slidePrev();
    },
    nextSlide() {
      if (!this.swiper) return;
      this.swiper.slideNext();
    },
    selectTab(tab) {
      this.tabActive = tab;
      this.getData();
    },
    getData() {
      this.loading = true;
      const uriIndex = (this.page.uri === '/article') ? 'article' : 'page';
      const uri = `${uriIndex}/${this.page.id}/section/${this.section.id}?${this.tabActive}=y`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.section.items = r.data.status === 200 && r.data.data ? r.data.data.items : [];
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.blockArticles{
  .viewAll{
    display: inline-block;
    border: #0747a6 2px solid;
    font-weight: 600;
  }
}

.cntNoData{
  text-align: center;
  padding: 60px 0;
  img{
    height: 96px;
    margin: 0 0 6px;
  }
  h4{
    margin: 0;
    font-size: 18px;
    font-weight: 500;
  }
  p{
    margin: 0;
    font-size: 15px;
    color: #767676;
  }
}

.cntLoading{
  height: 300px;
  background-image: url(../../assets/loading.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}

.tabCnt{
  margin: -6px 0 16px;
}

.newsCnt{
  position: relative;
  .sp{
    width: 40px; height: 40px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    z-index: 7;
    top: 50%;
    margin-top: -20px;
    background-size: 16px auto;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all .3s ease;
    border: #eee 1px solid;
    &:hover{
      box-shadow: 0 0 4px rgba(0, 0, 0, .1);
    }
    &.spl{
      left: -12px;
      background-image: url(../../assets/arrow-left-black.png);
    }
    &.spr{
      right: -12px;
      background-image: url(../../assets/arrow-right-black.png);
    }
  }
  .newsSc{
    transition: all .3s ease;
    // margin: -10px -10px -20px;
    margin-bottom: -10px;
    box-sizing: border-box;
    .newsItem{
      text-align: left;
      position: relative;
      padding: 10px 10px 20px;
      box-sizing: border-box;
      transition: all .3s ease;
      width: 25%;
      .newsIn{
        background-color: #fff;
        border: #eee 1px solid;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
        border-radius: 5px;
        overflow: hidden;
        height: 100%;
        position: relative;
        transition: all .3s ease;
      }
      .readMore{
        font-weight: 500;
        position: absolute;
        left: 22px; bottom: 16px;
      }
      .newsInfo{
        padding: 18px 22px 40px;
        position: relative;
      }
      .newsImg{
        height: 180px;
        background-color: #999;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        transition: all .3s ease;
        &.full{
          background-size: contain;
        }
        &.noImg{
          background-color: #e5e5e5;
          background-image: url(../../assets/icel-logo-grey.png);
          background-size: 64px auto;
          background-repeat: no-repeat;
          opacity: .64;
        }
        &.eventDate{
          background-color: rgb(0, 133, 82);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          .edDate{
            font-size: 82px;
            font-weight: 600;
            line-height: 1;
          }
          .edMonth{
            font-size: 24px;
            margin: -4px 0 0;
          }
        }
        @media (max-width: 1460px) {
          height: 240px;
        }
        @media (max-width: 1240px) {
          height: 220px;
        }
        @media (max-width: 1080px) {
          height: 200px;
        }
      }
      h4{
        color: #444;
        margin: 0 0 8px;
        font-size: 20px;
        line-height: 1.2;
        overflow: hidden;
        transition: all .3s ease;
        display: -webkit-box;
        -webkit-line-clamp: 3;
                line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .timestamp{
        color: #767676;
        font-size: 13px;
        margin: 0 0 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        a{
          color: inherit;
          &:hover{
            color: #008552;
          }
        }
        .bull{
          margin: 0 4px;
        }
      }
      p.newsDesc{
        margin: 0 0 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        box-sizing: border-box;
        min-height: 54px;
        color: #444;
        line-height: 1.2;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        @media (max-width: 1080px) {
          font-size: 15px;
        }
      }
    }
  }
  &.Thumbnails, &.Slider{
    .newsSc{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: -8px;
      .newsItem{
        width: 25%;
        padding-bottom: 10px;
        @media (max-width: 1340px) {
          width: 33.3333333%;
        }
        @media (max-width: 840px) {
          width: 50%;
        }
        @media (max-width: 640px) {
          width: 100%;
        }
      }
    }
  }
  &.List{
    .newsSc{
      display: block;
      margin: 0;
      .newsItem{
        width: auto;
        padding: 14px 0;
        border-top: #ddd 1px solid;
        @media (max-width: 620px) {
          padding: 20px 0;
        }
        .readMore{
          position: static;
          padding-left: 22px;
          @media (max-width: 620px) {
            padding: 0;
          }
        }
        h4{
          @media (max-width: 620px) {
            font-size: 18px;
          }
        }
        p.newsDesc{
          min-height: 0;
        }
        .timestamp{
          position: absolute;
          left: -200px; top: 22px;
          // text-transform: uppercase;
          font-size: 14px;
          font-weight: 500;
          @media (max-width: 1060px) {
            position: static;
            text-transform: none;
            font-size: 13px;
            font-weight: normal;
          }
          &.eventTs{
            background-color: rgb(0, 133, 82);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            width: 140px; height: 140px;
            border-radius: 5px;
            top: 0;
            @media (max-width: 1060px) {
              position: absolute;
              left: auto; right: -160px;
            }
            @media (max-width: 680px) {
              width: 94px; height: 94px;
              right: -100px;
            }
            .edDate{
              font-size: 62px;
              font-weight: 600;
              line-height: 1;
              @media (max-width: 680px) {
                font-size: 40px;
              }
            }
            .edMonth{
              font-size: 16px;
              margin: -2px 0 0;
              @media (max-width: 680px) {
                font-size: 14px;
                margin: 0;
              }
            }
          }
          .bull{
            display: block;
            visibility: hidden;
            height: 0;
            @media (max-width: 1060px) {
              visibility: visible;
              height: auto;
              display: inline;
            }
          }
        }
        .newsIn{
          position: relative;
          box-shadow: none;
          border: none;
          padding: 20px 400px 0 200px;
          box-sizing: border-box;
          min-height: 300px;
          background-color: transparent;
          @media (max-width: 1060px) {
            padding-left: 0;
          }
          @media (max-width: 840px) {
            padding-right: 220px;
            min-height: 220px;
          }
          @media (max-width: 620px) {
            padding: 0 100px 0 0;
            min-height: 100px;
          }
          &:hover{
            transform: none;
          }
          .newsInfo{
            padding-bottom: 0;
            @media (max-width: 620px) {
              padding: 0;
            }
          }
        }
        .newsImg{
          position: absolute;
          width: 360px; height: 240px;
          right: 0; top: 20px;
          border-radius: 5px;
          @media (max-width: 840px) {
            width: 200px; height: 180px;
          }
          @media (max-width: 620px) {
            width: 80px; height: 80px;
            top: 0;
          }
        }
        &.event{
          &:first-child{
            border: none;
          }
          @media (max-width: 1060px) {
            max-width: 720px;
            margin: 0 auto;
          }
          .newsIn{
            @media (max-width: 1060px) {
              padding-right: 160px;
              min-height: 180px;
            }
            @media (max-width: 680px) {
              padding-right: 100px;
              min-height: 120px;
            }
          }
          .newsImg{
            @media (max-width: 1060px) {
              display: none;
            }
          }
        }
      }
    }
  }
}
.newsNav{
  display: flex;
  justify-content: center;
  margin: 20px 0 0;
  .btn.primary{
    @media (max-width: 680px) {
      height: 45px;
      box-sizing: border-box;
      padding: 0 16px;
      line-height: 45px;
      font-size: 16px;
    }
  }
  .navCnt{
    display: flex;
    margin-left: auto;
    @media (max-width: 860px) {
      display: none;
    }
    &.nc2{
      display: none;
      @media (max-width: 860px) {
        display: block;
      }
    }
    .btn{
      padding: 0;
      width: 46px; height: 46px;
      margin-left: 10px;
      background-color: #fae502;
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      &.navp{
        background-image: url(../../assets/arrow-left-black.png);
      }
      &.navn{
        background-image: url(../../assets/arrow-right-black.png);
      }
      &:hover{
        background-color: #f9ce06;
      }
      &.disabled{
        background-color: #999;
        opacity: .3;
        cursor: default;
        box-shadow: none;
      }
    }
  }
}
</style>
